import { endpointDeclaration } from '@moojo/endpoints'
import { z } from 'zod'

export const GetFeedRequest = z.object({
  /* All info is passed in query string */
})

export type GetFeedRequest = z.infer<typeof GetFeedRequest>

export const GetFeedResponse = z.unknown()

export type GetFeedResponse = z.infer<typeof GetFeedResponse>

export const getFeedDeclaration = endpointDeclaration(GetFeedRequest, GetFeedResponse)

export const GetFeedRequestQueryParams = z.object({
  slug: z.string(),
})

export type GetFeedRequestQueryParams = z.infer<typeof GetFeedRequestQueryParams>
